// Navigation.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import useIsMobile from '../Components/UseIsMobile.js';


const Navigation = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const isMobile = useIsMobile(); // Detect mobile


  const handleMouseEnter = () => {
    setShowDropdown(true);
  };

  const handleMouseLeave = () => {
    setShowDropdown(false);
  };

  const handleClick = () => {
    if (isMobile) setShowDropdown(!showDropdown); // Toggle dropdown on click for mobile
  };


  return (
    <div className="navigation" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onClick={handleClick}>
      <span className="nav-item">Resources</span>
      {showDropdown && (
        <div className="dropdown">
          <ul>
            <li><Link to="/newcrit">Critical Insights</Link></li>  
            <li>
              <Link to ="/nonprofit">Activist Nonprofit Financial Filings</Link>
            </li>
            <li>
              <Link to ="/usdafoia">USDA FOIA Logs</Link>
            </li>
            <li>
              <Link to ="/fdafoia">FDA FOIA Logs</Link>
            </li>
          
            
          </ul>
        </div>
      )}
    </div>
  );
};

export default Navigation;

/*
 <li>
            <Link to ="/weeklyintsumar">Weekly Intsum AR</Link>
            </li>
            <li>
            <Link to ="/weeklyintsumes">Weekly Intsum ES</Link>
            </li>
 */
